import { render, staticRenderFns } from "./alertModal.vue?vue&type=template&id=40ab4ac0&scoped=true"
import script from "./alertModal.vue?vue&type=script&lang=js"
export * from "./alertModal.vue?vue&type=script&lang=js"
import style0 from "./alertModal.vue?vue&type=style&index=0&id=40ab4ac0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ab4ac0",
  null
  
)

export default component.exports